import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { CoachNavItems, ICoachNavItem } from '../nav.config';
import { CoachStateService } from '../../../../core/services/coach-state.service';
import { CoachAuthService } from '../../../../core/services/coach-auth.service';
import { ICoach } from '../../../../core/models/coach.model';
import { CoachChatUnreadService } from '../../../../core/services/coach-chat-unread.service';

@Component({
  selector: 'coach-sidebar',
  templateUrl: './coach-sidebar.component.html',
  styleUrl: './coach-sidebar.component.scss',
})
export class CoachSidebarComponent implements OnInit, OnDestroy {
  @Input() activeUrl = '';
  @Output() navigated = new EventEmitter();

  navItems: ICoachNavItem[] = CoachNavItems.filter(item => !item.hidden);
  coach$: Observable<ICoach | null>;
  unreadMessages = 0;

  destroyed$ = new Subject();

  constructor(
    private coachState: CoachStateService,
    private coachAuthService: CoachAuthService,
    private chatUnread: CoachChatUnreadService,
  ) {
    this.coach$ = this.coachState.currentCoach$;
  }

  ngOnInit(): void {
    this.chatUnread.unreadTotal$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(total => this.unreadMessages = total);
  }

  badgeCount(item: ICoachNavItem): number {
    return item.badgeKey === 'unreadMessages' ? this.unreadMessages : 0;
  }

  /** Capped so the badge keeps its size next to the title. */
  badgeLabel(count: number): string {
    return count > 9 ? '9+' : `${count}`;
  }

  isActive(item: ICoachNavItem): boolean {
    return item.exact ? (this.activeUrl === item.url) : this.activeUrl.startsWith(item.url);
  }

  onNavigate() {
    this.navigated.emit();
  }

  logout() {
    this.coachAuthService.logout();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
